import { RefundView } from './types/refundTypes';

export function createDefaultRefund(): RefundView {
  return {
    id: '',
    caseId: '',
    company: '',
    center: '',
    visitKey: '',
    accountNumber: '',
    lastName: '',
    firstName: '',
    status: 'Started',
    priority: 'Standard',
    sageStatus: '',
    refundStartDate: null,
    refundDetail: {
      refundCategory: 'NS', // Restore to match backend default (RefundType.NotSet)
      amount: 0,
      openBalances: false,
      openClaims: false,
      reason: '',
      creditCardRefund: false,
    },
    checkInfo: {
      checkNumber: null,
      checkDate: null,
      payableTo: '',
      streetAddress1: '',
      streetAddress2: '',
      city: '',
      state: '',
      zip: '',
    },
    notes: [],
    documents: [],
    approvals: [],
  };
}